import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from '../supabaseClient';

export default function ModuleSettings() {
  const { moduleId } = useParams();
  const [students, setStudents] = useState([]);
  const [selectedStudentId, setSelectedStudentId] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchStudents = async () => {
      const { data, error } = await supabase
        .from('profiles')
        .select('id, username, role')
        .eq('role', 'student');

      if (!error) setStudents(data);
    };

    fetchStudents();
  }, []);

  const generateCode = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    return Array.from({ length: 6 }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
  };

  const handleGenerate = async () => {
    if (!selectedStudentId) {
      setStatus('Please select a student.');
      return;
    }

    setLoading(true);
    setStatus('');

    const code = generateCode();
    const expiresAt = new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString();

    const { error } = await supabase
      .from('one_time_access_codes')
      .insert([{ code, module_id: moduleId, user_id: selectedStudentId, expires_at: expiresAt }]);

    if (error) {
      console.error(error);
      setStatus('❌ Failed to create unlock code.');
    } else {
      setStatus(`✅ Unlock code generated: ${code}`);
    }

    setLoading(false);
  };

  return (
    <div className="max-w-xl mx-auto p-6 space-y-6">
      <h2 className="text-2xl font-bold text-gray-800">Generate Unlock Code</h2>

      <div>
        <label className="block mb-2 text-gray-700">Select Student:</label>
        <select
          className="w-full p-2 border border-gray-300 rounded"
          value={selectedStudentId}
          onChange={(e) => setSelectedStudentId(e.target.value)}
        >
          <option value="">-- Select --</option>
          {students.map((s) => (
            <option key={s.id} value={s.id}>
              {s.username}
            </option>
          ))}
        </select>
      </div>

      <button
        onClick={handleGenerate}
        disabled={loading}
        className="bg-blue-600 hover:bg-blue-500 text-white px-4 py-2 rounded disabled:opacity-50"
      >
        {loading ? 'Generating...' : 'Generate Code'}
      </button>

      {status && <p className="text-sm mt-4">{status}</p>}
    </div>
  );
}
